const info = {
    CN: {
        //中文翻译
        banner: {
            title1: "SiGReal Empowers AI to ",
            title2: "Transform Risk into Return",
            titleSpan: "",
            content: "从风险创造价值",
            subTitle: "",
            slogan: "",
        },
        aboutUs: {
            title: "公司简介",
            content1:
                "宏瓴科技以“AI大模型”为核心自主研发的全栈式风险评估系统，利用Transformer+自监督预训练技术、强化学习微调技术及图神经网络数据挖掘技术等技术实现跨场景的风险模型训练、迁移和场景化微调，通过端到端的技术解决方案加精细化的运营手段，为保险、物流、配送、主机厂、营运出行平台和电商等行业提供行业领先的数字化运营管控和风险减量（识别、预测、量化）平台，已在实际业务场景中实现产品化落地并发挥重要作用。通过平台引导传统作业流程升级并提高人效，真正实现从源头降低风险。",
            content2:
                "核心团队来自清华大学、南开大学、中科院、波士顿大学等国内外知名院校，曾就职世界500强头部科技公司的核心研发和管理岗位，拥有丰富的 人工智能算法、交通运输物流 、智慧农业及电商等复合产业经验，实现“数据-算法-业务场景应用”闭环，确保模型效果持续领跑行业。",
            content3: "",
        },
        ourCulture: {
            title: "企业文化",
            cultureTitle: [
                "成就客户",
                "务实落地",
                "正直担当",
                "延迟满足感",
                "强执行力",
                "乐观进取",
            ],
            cultureIntro: [
                "才是成就自己",
                "实事求是，真正解决问题",
                "诚实大气，勇于担当，有责任心",
                "习惯做正确且难的事",
                "敢打仗，打胜仗",
                "追求理想，挑战困难，永不放弃",
            ],
        },
        service: {
            services: {
                title: "我们的服务",
                text1: "宏瓴科技致力于将人工智能技术应用在保险、交通运输行业、工业、电商等多维度行业场景，自主研发创新的个体（包括但不限于人、机器等）行为风险评估模型与风险控制方案，不仅深入探索个体行为模式，更锁定潜在风险点，实现风险成本的个体化精确度量。",
                text2: "在数字化风控、智能出行、绿色能源后市场以及即时配送等新兴领域，提供一站式的风控技术解决方案，通过结合人工智能算法与前沿的产品创新设计理念，优化现有风控流程，催生数智化风控领域新生态，构建行业专属算法大模型及全面风险管控。",
            },
            scopeOfService: {
                title: "服务类型",
                list: [
                    {
                        title: "AI+物流配送平台",
                        subTitle:
                            "全栈式风险评估管理平台，为新兴行业提供安全保障",
                        text1: "风险主体和风险事件识别",
                        text2: "风险预警和提前干预",
                        text3: "识别欺诈风险、降赔减损",
                        look: "查看详情",
                    },
                    {
                        title: "AI+出行/商用车平台",
                        subTitle:
                            "车队风险管理的闭环解决方案，降低车队运营成本",
                        text1: "刻画驾驶员风险画像",
                        text2: "复现车辆行程和轨迹",
                        text3: "提供车队安全驾驶运营方案",
                        look: "查看详情",
                    },
                    {
                        title: "AI+主机厂",
                        subTitle:
                            "“数据采集与处理—客户运营—风险管控”全产业链解决方案",
                        text1: "刻画车主全息画像",
                        text2: "降低车辆风险成本",
                        text3: "丰富车主服务生态圈",
                        look: "查看详情",
                    },
                    {
                        title: "AI+农险+测绘",
                        subTitle:
                            "无人机测绘与数据采集——投保风险控制——AI精准理赔，农险自投保至理赔全链条解决方案",
                        text1: "无人机测绘",
                        text2: "精准投保",
                        text3: "精准理赔",
                        look: "查看详情",
                    },
                ],
            },
        },
        quote: {
            title: "Reinvent Risk Control with Advanced AI",
            subTitle: "从算法模型到系统应用，全链路自主研发",
            sign: "",
        },
    },
    EN: {
        //英文翻译
        banner: {
            title1: "SiGReal Empowers AI to ",
            title2: "Transform Risk into Return",
            titleSpan: "",
            content: "",
            subTitle: "",
            slogan: "",
        },
        aboutUs: {
            title: "About Us",
            content1:
                'SiGREAL Tech has independently developed a full-stack risk assessment system with "AI large models" at its core. Leveraging cutting-edge technologies such as transformer+self-supervised pre-training, reinforcement learning fine-tuning, and graph neural network data mining, the system achieves cross-scenario training, transfer, and contextual fine-tuning for risk models. Through integrated end-to-end tech solutions and refined operational tactics, it delivers industry-leading digital operation management and risk mitigation (identification, prediction, quantification) platforms for insurance , logistics, distribution, automotive OEMs, mobility platforms and SMEs. These solutions have been successfully commercialized in real-world business scenarios, driving the upgrading of traditional workflows, enhancing operational efficiency, and achieving genuine risk reduction at the source.',
            content2:
                'The core team consists of professionals from prestigious institutions worldwide, including Tsinghua University, Nankai University, Chinese Academy of Sciences, and Boston University. With prior experience in key R&D and management roles at Fortune Global 500 tech giants, they possess extensive interdisciplinary expertise spanning AI algorithms, transportation & logistics, smart agriculture, and SMEs. This enables the seamless closure of the "data-algorithm-business application" loop, ensuring sustained industry leadership in model performance.',
            content3: "",
        },
        ourCulture: {
            title: "Our Culture",
            cultureTitle: [
                "Pursue Customer Success",
                "Down-to-Earth",
                "Integrity",
                "Delayed Gratification",
                "Execution",
                "Proactivity",
            ],
            cultureIntro: ["", "", "", "", "", ""],
        },
        service: {
            services: {
                title: "Services",
                text1: "",
                text2: `In the emerging fields of digital risk management, smart mobility, green energy aftermarket, and instant delivery, we offer one-stop risk management technology solutions. By integrating artificial intelligence algorithms with advanced product innovation and design philosophies, we optimize the existing risk management processes. This approach cultivates a new ecosystem in the digital intelligence risk control sector, establishing industry-specific algorithmic big models and comprehensive risk monitoring and control systems.`,
            },
            scopeOfService: {
                title: "Scope Of Services",
                list: [
                    {
                        title: "AI+Logistics/Delivery Platforms",
                        subTitle:
                            "Building a full-stack risk assessment and management platform to provide safety assurance for emerging industries.",
                        text1: "Identifying Risk Entities and Risk Events",
                        text2: "Risk Alerts and Proactive Intervention",
                        text3: "Identifying Fraud Risks and Reducing Claims and Losses",
                        look: "LEARN MORE",
                    },
                    {
                        title: "AI+Mobility/Commercial Vehicle Platforms",
                        subTitle:
                            "Providing a Closed-Loop Fleet Risk Management Solution to Reduce Fleet Operational Costs.",
                        text1: "Creating Driver Risk Profiles",
                        text2: "Replicating Vehicle Trips and Trajectories",
                        text3: "Providing Fleet Safe Driving Operational Solutions",
                        look: "LEARN MORE",
                    },
                    {
                        title: "AI+Automotive OEM",
                        subTitle:
                            '"Data Collection and Processing—Customer Operations—Risk Management" End-to-End Solution.',
                        text1: "Creating a Comprehensive Vehicle Owner Profile",
                        text2: "Reducing Vehicle Risk Costs",
                        text3: "Enriching the Vehicle Owner Service Ecosystem",
                        look: "LEARN MORE",
                    },
                    {
                        title: "AI+Agricultural Insurance+Mapping",
                        subTitle:
                            "Drone mapping and data collection, underwriting risk control, and AI-powered precise claims for end-to-end agricultural insurance.",
                        text1: "Drone Mapping",
                        text2: "Precise Underwriting",
                        text3: "Precise Claims",
                        look: "LEARN MORE",
                    },
                ],
            },
        },
        quote: {
            title: "Reinvent Risk Control with Advanced AI",
            subTitle: "",
            sign: "",
        },
    },
};
export default info; //需要暴露出去
